/* eslint-disable
    func-names,
    max-len,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const deps = ['Conversation', 'AvatarUrl'];

const CommentCtrl = function (Conversation, AvatarUrl) {
  const conversation = new Conversation(this.conversationId);
  const conversationVM = conversation.$viewModel();

  this.editMode = false;

  const resetComment = () =>
    (this.comment = _.cloneDeep(conversationVM.comments[Number(this.commentIndex)]));
  conversation.$onSet(resetComment);

  this.enterEditMode = function () {
    return (this.editMode = true);
  };

  this.cancelEditMode = e => {
    if (!e || e.keyCode === 27) {
      resetComment();
      return (this.editMode = false);
    }
  };

  this.editComment = () =>
    conversation
      .$editComment(this.commentIndex, this.comment.body)
      .then(() => this.cancelEditMode());

  this.avatarUrl = AvatarUrl.getAvatar;
};

CommentCtrl.$inject = deps;

module.exports = CommentCtrl;
